import type { SkillDesignation } from '@/models/taxonomy/skills';
import type { CheckedSkill } from '@/packages/skill-management/context/types';

export const markSkillsAsChecked = (
  skills: SkillDesignation[],
  selectedSkills?: SkillDesignation[]
): CheckedSkill[] => {
  const selectedIds = selectedSkills?.map((s) => s.skill.id) ?? [];

  return skills.map((skill) => ({
    ...skill,
    checked: selectedIds.includes(skill.skill.id),
  }));
};
